module.exports = __webpack_public_path__ + "img/godot-blog.d2e70f09.jpg";